import React, { useState } from 'react';
import { Col, Form, Radio, Row, Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useTranslation } from 'react-i18next';
import Button from '../../components/Button/Button';
import { checkIsFormValid } from '../../utils/formHelpers';
import { colorBorder } from '../../styles/theme';

type InitialSegmentationFormProps = {
  onFinish: (values: SegmentationFormValues) => void;
};

export type SegmentationFormValues = {
  hasMerchantUsedExpress: boolean;
};

const spaceItemCustomStyle = { border: `1px solid ${colorBorder}`, padding: '8px 10px', borderRadius: 2 };

const InitialSegmentationForm = ({ onFinish }: InitialSegmentationFormProps) => {
  const [form] = useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const { t } = useTranslation();

  return (
    <Form
      onValuesChange={() => setIsFormValid(checkIsFormValid(form, ['hasMerchantUsedExpress'], true))}
      requiredMark={true}
      onFinish={onFinish}
      form={form}
      layout="vertical"
      data-testid="InitialSegmentationForm"
    >
      <Row>
        <Col xs={24}>
          <Form.Item
            name="hasMerchantUsedExpress"
            label={t('onboarding.segmentation.doYouUseExpress')}
            rules={[{ required: true }]}
          >
            <Radio.Group style={{ width: '100%' }} buttonStyle="solid">
              <Space direction="vertical" style={{ width: '100%', rowGap: 12 }}>
                <div style={spaceItemCustomStyle}>
                  <Radio style={{ width: '100%' }} value={true} data-testid="hasMerchantUsedExpress_Yes">
                    {t('onboarding.segmentation.yes')}
                  </Radio>
                </div>
                <div style={spaceItemCustomStyle}>
                  <Radio style={{ width: '100%' }} value={false} data-testid="hasMerchantUsedExpress_No">
                    {t('onboarding.segmentation.no')}
                  </Radio>
                </div>
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Row style={{ marginTop: 48 }}>
        <Col xs={24}>
          <Button disabled={!isFormValid} type="primary" size="large" block htmlType="submit">
            {t('onboarding.segmentation.continue')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default InitialSegmentationForm;
